<template>
  <div>
    <div id="about">

      <section id="overview" class="about-main" v-scroll-reveal>
        <div class="about-inner">
          <h1 id="greeting" @click="randomMessage()">
            <span>{{activeMessage}}Dan Araujo.</span>
            <div id="pointer"></div>
          </h1>

          <h5>I’m a product designer with a passion for all things digital. I love digital so much that I went to the University of Connecticut and got an expensive piece of paper to prove it. </h5>
          <h5>I create dynamic experiences through the use of UI design, user-centric strategy, code, and motion graphics. I’m perpetually learning, researching, and sharpening my skills in these areas, so I enjoy tackling all types of challenges using creative solutions. I apply a detail-oriented, user-first mindset on every step of a project, from strategy to production to adding the final coat of (digital) paint.</h5>
          <h5>I currently work at <a href="https://joinsubtext.com" target="_blank">Subtext</a> as Head of Product, and am open to freelance opportunities.</h5>
        </div>
      </section>

      <section id="skills-header" class="header-bar" v-scroll-reveal>
        <div class="about-inner">
          <h2><span>Skills</span> and Software</h2>
        </div>
      </section>

      <section id="skills" class="about-main" v-scroll-reveal>
        <div class="about-inner">

          <div class="skill-group">
            <h5>Web Development</h5>
            <ul>
              <about-skill id="html" name="HTML & CSS" />
              <about-skill id="js" name="Javascript / ES6" />
              <about-skill id="vue" name="Vue" />
              <about-skill id="svelte" name="Svelte" />
            </ul>
          </div>

          <div class="skill-group">
            <h5>UI Design</h5>
            <ul>
              <about-skill id="figma" name="Figma" />
              <about-skill id="sketch" name="Sketch" />
              <about-skill id="xd" name="Adobe XD" />
              <about-skill id="framer" name="Framer" />
            </ul>
          </div>

          <div class="skill-group">
            <h5>Graphic Design</h5>
            <ul>
              <about-skill id="ps" name="Photoshop" />
              <about-skill id="ai" name="Illustrator" />
              <about-skill id="id" name="InDesign" />
              <about-skill id="keynote" name="Keynote" />
            </ul>
          </div>

          <div class="skill-group">
            <h5>Motion</h5>
            <ul>
              <about-skill id="ae" name="After Effects" />
              <about-skill id="pr" name="Premiere" />
              <about-skill id="c4d" name="Cinema 4D" />
            </ul>
          </div>

        </div>
      </section>

      <section id="experience-header" class="header-bar" v-scroll-reveal>
        <div class="about-inner">
          <h2><span>Experience</span> and Education</h2>
        </div>
      </section>

      <section id="experience" class="about-main" v-scroll-reveal>

        <about-job
          v-for="job in jobs"
          :key="job.id"
          :company="job.company"
          :dates="job.dates"
          :jobtitle="job.jobtitle"
          :bulletpoints="job.bulletpoints"
          :emoji="job.emoji" />

      </section>
      <!--
      <a href="/img/general/Dan_Araujo_Resume_2019.pdf"
      target="_blank"
      id="resume"
      class="marquee left"
      v-scroll-reveal>
        <marquee-text :repeat="10" :duration="6.5">
          <h4>download resume <span class="emoji"><img src="img/emoji/page.svg" alt="Resume emoji"></span>&nbsp;</h4>
        </marquee-text>
      </a> -->

      <a href="mailto:dancaraujo@gmail.com"
      id="email"
      class="marquee right"
      v-scroll-reveal>
        <marquee-text :repeat="10" :duration="5">
          <h4>email me <span class="emoji"><img src="img/emoji/envelope.svg" alt="Email emoji"></span>&nbsp;</h4>
        </marquee-text>
      </a>

      <a href="https://www.linkedin.com/in/dancaraujo"
      target="_blank"
      id="linkedin"
      class="marquee left"
      v-scroll-reveal>
        <marquee-text :repeat="10" :duration="5.25">
          <h4>connect with me <span class="emoji"><img src="img/emoji/handshake_hmn_y2.svg" alt="Handshake emoji"></span>&nbsp;</h4>
        </marquee-text>
      </a>

    </div>

    <app-footer></app-footer>

  <vue-headful title="DA | About" />
  </div>
</template>

<script>
import AppFooter from '../components/Footer.vue'
import AboutSkill from '../components/about/Skill.vue'
import AboutJob from '../components/about/Job.vue'
import greetings from '../assets/greetings.json'
import jobs from '../assets/experience.json'
import MarqueeText from 'vue-marquee-text-component'
import anime from 'animejs'

export default {
  components: { AppFooter, AboutSkill, AboutJob, MarqueeText },
  data () {
    return {
      greetings: greetings.messages,
      jobs: jobs,
      activeMessage: "Hello, I'm ",
      interval: 4000
    }
  },
  methods: {
    randomMessage: function () {
      this.activeMessage = this.greetings[Math.floor(Math.random() * this.greetings.length)]
    }
  },
  beforeMount () {
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
      document.querySelector('#app').style.display = 'none'
    }
  },
  mounted () {
    let d = new Date()
    let week = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    let weekGreeting = `"Happy ${week[d.getDay()]}" - `
    // eslint-disable-next-line no-unused-expressions
    this.greetings.includes(weekGreeting) ? null : this.greetings.push(weekGreeting)

    function newGreetingAnimation () {
      anime.remove('#greeting')

      anime({
        targets: '#greeting',
        scale: [1.5, 1],
        rotate: [-1, 0],
        duration: 800,
        easing: 'easeOutExpo'
      })
    }

    document.querySelector('#greeting').addEventListener('click', newGreetingAnimation, false)

    let clickAttention = anime.timeline({
      easing: 'easeOutCirc',
      autoplay: false,
      duration: 750
    })

    clickAttention
      .add({
        targets: '#pointer',
        left: [-75, -15],
        bottom: [-75, -15],
        opacity: [0, 1],
        scale: [2.5, 1],
        rotate: 25
      }, 0)

      .add({
        targets: '#pointer',
        scale: [1, 0.85, 1, 0.9, 1]
      }, '-=150')

      .add({
        targets: '#greeting',
        scale: [1, 0.9, 1, 0.95, 1]
      }, '-=750')

      .add({
        targets: '#pointer',
        left: [-15, -100],
        rotate: [25, -15],
        opacity: [1, 0],
        scale: [1, 0.75],
        duration: 1000
      })

    setTimeout(() => {
      clickAttention.play()
    }, 4000)
  }
}

</script>

<style lang="scss" scoped>

h1,h2,h3 {
  font-family: $display-font;
}

h1 {
  font-size: 2rem;
  line-height: 100%;
}

h2 {
  font-size: 2rem;
  line-height: 100%;
  text-align: center;

  @include tablet-below {
    text-align: left;
  }
}

h4 {
  font-family: $display-font;
  font-size: 2.25rem;
}

h5 {
  font-family: $body-font;
  font-size: 1rem;
  line-height: 1.75rem;
}

p {
  font-weight: bold;
}

span {font-family: inherit;}

#about {
  @extend %container;
  box-sizing: border-box;
}

section, .marquee {
  display: block;
  box-shadow: $standard-shadow;
  background-color:$white;
  margin-bottom: $grid-gap;
  overflow: hidden;
}

.about-main, .header-bar {
  display: flex;
  justify-content: center;
  padding: $grid-gap;

  .about-inner {
    width:60%;
    max-width: 690px;

    @include tablet-below {
      width: 90%;
    }
  }
}

.about-main {
  border-top: 5px solid rgba(0, 0, 0, .12);
}

.header-bar {
  margin-bottom: 0;
}

#overview {
  background-color: $black;
  color: $gray3;
  padding: 5rem 0;
  background-image: url('/img/general/city.jpg');
  background-size: cover;
  background-position: center;
  background-blend-mode: soft-light;
  background-repeat: no-repeat;

  @include tablet-below {
    padding: 5rem 1rem
  }

  span {color: $white;}

  #greeting {
    @extend %linkify;
    transform-origin: left;
    text-align: left;
    //font-size: 3vw;
    position: relative;
    z-index: 1;

    &:hover span{
      opacity: .8;
    }

    $emoji-size: 32px;
    #pointer {
      display: block;
      background-image: url('/img/emoji/point_up_hmn_y2.svg');
      background-size: $emoji-size $emoji-size;
      height: $emoji-size;
      width: $emoji-size;
      position: absolute;
      left: 0;
      bottom: 0;
      opacity: 0;
    }
  }

  h5 {
    padding-top: 1rem;
    font-weight: 400;
    // border-top: 1px solid $gray2;
  }
}

#skills-header {
  background-color: $gray8;
  color: $gray3;
  span {color: $white};
}

#skills {
  background-color: $gray6;
  color: $white;
  span, h5 {color: $white};

  .about-inner {
    display: flex;
    justify-content: space-between;
    flex-flow: wrap;
  }

  .skill-group {
      width: auto;
      padding-right: 1.5rem;

    @include phone-only {
      margin-bottom: 1rem;
    }
  }

  ul {
    list-style: none;
    padding: 0;
  }
}

#experience-header {
  background-color: $gray1;
  color: $gray5;
  span {color: $black;}
}

#experience {
  background-color: $white;
  color: $gray6;
  flex-direction: column;
}

.marquee {
  padding: 10px 0;
  @extend %linkify;
  transition: all .4s ease-out;

  h4 {
    transition: transform .4s cubic-bezier(0.18, 0.89, 0.32, 1.28);
  }

  .emoji {
    display: inline;

    img {
      width: 2.25rem;
      margin-bottom: -0.375rem;
    }
  }

  &:hover {
    background-color: $gray6 !important;
    color: $gray3 !important;

    .emoji {
      display: none;
    }

    h4 {
      transform: rotate(-3deg);
    }
  }
}

#resume {
  background-color: $gray3;
  color: $black;
}

#email {
  background-color: $gray5;
  color: $gray1;
}

#linkedin {
  background-color: $gray8;
  color: $gray2;
  margin-bottom: 0;
}

</style>
